import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'desc', label: 'Description'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/professions/status/AC'}
    useIPA.get(param).then(response => {
      const profession = {
        rows : response.data.data
      }
      commit('setData', {...profession})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/profession/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const specialist = []
      for (let is = 0, s = formData.select_3.length; is < s; is++) {
        specialist.push({specialist_id:formData.select_3[is]}) 
      }
      const document = []
      for (let is = 0, s = formData.select_4.length; is < s; is++) {
        document.push({document_id:formData.select_4[is]}) 
      }
      const service = []
      for (let is = 0, s = formData.select_5.length; is < s; is++) {
        service.push({legal_service_id:formData.select_5[is]}) 
      }
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2,
        specialist: specialist,
        document: document,
        legalservice: service
      }
      const param = { rawData: rawData, url: 'dashboard/master/profession', id: formData.id}
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'profession-in' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/profession', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, profession) {
    state.items = profession.rows
    state.totalRows = profession.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
